import { render } from "./ResetTokenExpiredView.vue?vue&type=template&id=6171450c"
import script from "./ResetTokenExpiredView.vue?vue&type=script&lang=js"
export * from "./ResetTokenExpiredView.vue?vue&type=script&lang=js"

import "./ResetTokenExpiredView.vue?vue&type=style&index=0&id=6171450c&lang=scss"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__